import React, { useEffect, useState, createContext, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styled from "styled-components";
import Sidebar from "./components/Sidebar";
import "./App.css";
import Cookies from "js-cookie";
import axios from "axios";
import Footer from "./components/Footer";
import ColorPicker from "./components/ColorPicker";

const AccountInfo = lazy(() => import("./pages/AccountInfo"));
const RechargeSupme = lazy(() => import("./pages/RechargeSupme"));
const WithDrawMoney = lazy(() => import("./pages/WithDrawMoney"));
const TransferMoney = lazy(() => import("./pages/TransferMoney"));
const Collaborator = lazy(() => import("./pages/Collaborator"));
const Agency = lazy(() => import("./pages/Agency"));
const ContactAd = lazy(() => import("./pages/ContactAd"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const RechargeCoinSupme = lazy(() => import("./pages/RechargeCoinSupme"));
const ScratchCard = lazy(() => import("./pages/ScratchCard"));
const Summary = lazy(() => import("./pages/Sumary"));

const Content = styled.div`
  margin: ${({ isOpen }) => (isOpen ? '25px 25px 25px 275px' : '0')};
  transition: margin-left 350ms;
  padding: ${({ isLoggedIn }) => (isLoggedIn ? '20px' : '0')};
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const StyledFooter = styled(Footer)`
  display: flex;
  justify-content: space-around;
  background: linear-gradient(135deg, #FFF7A1, #FFEBA1, #FFD700);
  padding: 10px 0;
  margin: 0 10px;
  position: fixed;
  bottom: 0;
  width: ${({ isOpen }) => (isOpen ? 'calc(100% - 315px)' : 'calc(100% - 20px)')} !important;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  border-radius: 5px;
`;

export const UserContext = createContext();

const applyBackgroundFromLocalStorage = () => {
  const savedBgColor = localStorage.getItem('bgColor') || 'linear-gradient(135deg, #FFF7A1, #FFEBA1, #FFD700)';

  const gradientToLightColor = {
    'linear-gradient(135deg, #FFF7A1, #FFEBA1, #FFD700)': '#FFF8D7',
    'linear-gradient(135deg, #F9D29D, #F6B873, #FF7E39)': '#FDE6D3',
    'linear-gradient(135deg, #DFF5C9, #BCE6A8, #8BCB73)': '#EFFAE5',
    'linear-gradient(135deg, #FDE2E4, #FAB1A0, #FF7676)': '#FEEDEE',
    'linear-gradient(135deg, #D2EFFF, #A1D8FF, #70BAFF)': '#EAF9FF',
    'linear-gradient(135deg, #f44034, #f8836f, #ffbc93)': '#ffe0e1'
  };

  const lightColor = gradientToLightColor[savedBgColor] || '#FFFBE5';

  document.documentElement.style.background = savedBgColor;

  const appContainer = document.querySelector('.app_container');
  if (appContainer) {
    appContainer.style.background = lightColor;
  }
};

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [bgColor, setBgColor] = useState(localStorage.getItem('bgColor') || 'linear-gradient(135deg, #FFF7A1, #FFEBA1, #FFD700)');

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogin = (userData) => {
    setIsLoggedIn(true);
    setUser(userData);
    setSidebarOpen(!sidebarOpen); 
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
    Cookies.remove('key');
  };

  useEffect(() => {
    const checkLoginState = async () => {
      const key = Cookies.get('key');
      if (key) {
        const [username, password] = key.split('_');
        try {
          const res = await axios.post(API_BASE_URL + '/login', { username, password });
          if (res.data.length > 0) {
            handleLogin(res);
          }
        } catch (err) {
          console.error('Error during re-login:', err);
        }
      }
    };
    checkLoginState();
  }, []);

  useEffect(() => {
    applyBackgroundFromLocalStorage();
  }, []);

  console.log("sidebar: ",sidebarOpen);

  return (
    <div className="app_container">
      <ColorPicker setBgColor={setBgColor} />
      <UserContext.Provider value={{ user, setUser }}>
        {isLoggedIn ? (
          <Router>
            <Sidebar isOpen={sidebarOpen} isLoggedIn={isLoggedIn} toggleSidebar={toggleSidebar} bgColor={bgColor} />
            <Content isOpen={sidebarOpen}>
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  <Route path="/" element={<RechargeCoinSupme />} />
                  <Route path="/accountInfo" element={<AccountInfo />} />
                  <Route path="/rechargeSupme" element={<RechargeSupme />} />
                  <Route path="/withDrawMoney" element={<WithDrawMoney />} />
                  <Route path="/transfermoney" element={<TransferMoney />} />
                  <Route path="/agency" element={<Agency />} />
                  <Route path="/setting" element={<ContactAd />} />
                  <Route path="/summary" element={<Summary />} />
                  <Route path="/collaborator" element={<Collaborator />} />
                  <Route path="/scratchcard" element={<ScratchCard />} />
                </Routes>
              </Suspense>
              <StyledFooter isOpen={sidebarOpen} bgColor={bgColor} />
            </Content>
          </Router>
        ) : (
          <Router>
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                  <Route path="/" element={<Login onLogin={handleLogin} />} />
                  <Route path="/register" element={<Register />} />
                </Routes>
            </Suspense>
          </Router>
        )}
      </UserContext.Provider>
    </div>
  );
}

export default App;
